import { request } from "services/api/util";

class StoreService {
  async getListStore(param) {
    const queryParams = Object.entries(param)
      .filter(([, value]) => value !== undefined && value !== null)
      .reduce((obj, [key, value]) => {
        if (key === "brands" && Array.isArray(value)) {
          obj[key] = value.join(",");
        } else {
          obj[key] = value;
        }
        return obj;
      }, {});

    const config = {
      method: "get",
      url: `admin/store`,
      params: queryParams,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
      paramsSerializer: (params) => {
        return Object.entries(params)
          .map(([key, value]) => `${key}=${value}`)
          .join("&");
      },
    };
    return request(config);
  }

  async getDetailStore(storeCode, params) {
    const config = {
      method: "get",
      url: `admin/store/${storeCode}`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };

    return request(config);
  }
}

export default new StoreService();
